export default "__VITE_ASSET__CLkYz96v__"